import { createContext } from 'react'

import { MarketplaceBusinessCreditCard } from '../Offers/queries/business-credit-card-offers-query.js'
import { MarketplaceLoanOffer } from '../Offers/queries/loan-offers-query.js'
import { MarketplacePersonalCreditCard } from '../Offers/queries/personal-credit-card-offers-query.js'
import { MarketplaceProductOption } from '../Offers/queries/product-category-offers.query.js'

export type {
  MarketplaceBusinessCreditCard,
  MarketplaceLoanOffer,
  MarketplacePersonalCreditCard,
  MarketplaceProductOption,
}

export type OfferData = MarketplaceBusinessCreditCard | MarketplaceLoanOffer | MarketplaceProductOption

export const creditCardCategory = 'businessCreditCards'

export const isCreditCardOffer = (offer: Offer): offer is Offer & { data: MarketplaceBusinessCreditCard } => {
  return offer.category === creditCardCategory
}

export const personalCreditCardCategory = 'personalCreditCards'

export const isPersonalCreditCardOffer = (offer: Offer): offer is Offer & { data: MarketplacePersonalCreditCard } => {
  return offer.category === personalCreditCardCategory
}

export const loanCategory = 'businessLoans'

export const isLoanOffer = (offer: Offer): offer is Offer & { data: MarketplaceLoanOffer } => {
  return offer.category === loanCategory
}

export const isProductOptionOffer = (offer: Offer): offer is Offer & { data: MarketplaceProductOption } => {
  return !isCreditCardOffer(offer) && !isPersonalCreditCardOffer(offer) && !isLoanOffer(offer)
}

export type Offer = {
  id: string
  category: string
  data: OfferData
}

type OfferProviderContextType = {
  offers: Offer[]
}

export const OffersProviderContext = createContext<OfferProviderContextType | undefined>(undefined)
